module.exports = __webpack_public_path__ + "static/media/milex-pessaries-product.9090c314.jpg";